const getRemainingTimeToEndMonth = () => {
  const date = new Date();
  const endTime = new Date(date.getFullYear(), date.getMonth() + 1, 0, 0);

  const remainingMinutes = date.getMinutes() - endTime.getMinutes();
  const remainingHours = date.getHours() - endTime.getHours();
  const remainingDays = endTime.getDate() - date.getDate();

  const remainingTime = remainingDays
    ? `${remainingDays} days`
    : remainingHours
    ? `${remainingHours} hours`
    : `${remainingMinutes} minutes`;

  return remainingTime;
};

export default getRemainingTimeToEndMonth;
